<template>
  <div class="app-container">
    <div class="page-title">
      <h2>{{ $t('superviseur.rapport.title') }}</h2>
    </div>

    <el-card class="box-card">
      <div class="filter-container">
        <el-select
          v-model="query.campagne_agricole_id"
          class="mr-15 filter-item"
          style="width: 220px;"
          :placeholder="$t('recolte.campagne')"
          @change="loadRapport"
        >
          <el-option
            v-for="campagne in campagnes"
            :key="campagne.id"
            :label="campagne.nom"
            :value="campagne.id"
          />
        </el-select>

        <el-date-picker
          v-model="dateRange"
          type="daterange"
          class="mr-15 filter-item"
          :start-placeholder="$t('superviseur.rapport.dateDebut')"
          :end-placeholder="$t('superviseur.rapport.dateFin')"
          value-format="yyyy-MM-dd"
          @change="handleDateChange"
        />

        <el-button v-waves type="primary" icon="el-icon-search" @click="loadRapport">
          {{ $t('general.search') }}
        </el-button>
        <el-button type="success" icon="el-icon-download" :loading="exporting" @click="exportExcel">
          {{ $t('superviseur.rapport.export') }}
        </el-button>
      </div>

      <el-table v-loading="loading" :data="list" border fit highlight-current-row style="width: 100%">
        <el-table-column align="center" :label="$t('controleur.controleur')" prop="nom" min-width="160" />
        <el-table-column align="center" :label="$t('general.code')" prop="code" width="100" />
        <el-table-column align="center" :label="$t('superviseur.equipe.up')" prop="unite_production" min-width="140" />
        <el-table-column align="center" :label="$t('superviseur.rapport.ciTermines')" prop="ci_termines" width="100" />
        <el-table-column align="center" :label="$t('superviseur.rapport.ciEnAttente')" prop="ci_en_attente" width="110" />
        <el-table-column align="center" :label="$t('superviseur.rapport.ciApprouves')" prop="ci_approuves" width="110" />
        <el-table-column align="center" :label="$t('superviseur.types.formation')" prop="formations" width="100" />
        <el-table-column align="center" :label="$t('superviseur.types.audit')" prop="audits" width="90" />
      </el-table>
    </el-card>
  </div>
</template>

<script>
import Resource from '@/api/resource';
import waves from '@/directive/waves';
import { getSuperviseurRapport, exportSuperviseurRapport } from '@/api/superviseur';

const campagneResource = new Resource('campagne_agricoles');

export default {
  name: 'SuperviseurRapport',
  directives: { waves },
  data() {
    return {
      list: [],
      campagnes: [],
      loading: false,
      exporting: false,
      dateRange: null,
      query: {
        campagne_agricole_id: null,
        date_debut: null,
        date_fin: null,
      },
    };
  },
  created() {
    this.loadCampagnes();
  },
  methods: {
    handleDateChange(range) {
      if (range && range.length === 2) {
        this.query.date_debut = range[0];
        this.query.date_fin = range[1];
      } else {
        this.query.date_debut = null;
        this.query.date_fin = null;
      }
    },
    async loadCampagnes() {
      const { data } = await campagneResource.list({ limit: 100 });
      this.campagnes = data || [];
      try {
        const { data: current } = await campagneResource.sublist('/en_cours');
        this.query.campagne_agricole_id = current && current.id ? current.id : (this.campagnes[0] ? this.campagnes[0].id : null);
      } catch (error) {
        this.query.campagne_agricole_id = this.campagnes[0] ? this.campagnes[0].id : null;
      }
      this.loadRapport();
    },
    async loadRapport() {
      this.loading = true;
      try {
        const response = await getSuperviseurRapport(this.query);
        this.list = response.data || [];
      } catch (error) {
        console.error(error);
        this.$message.error(this.$t('general.errorOccurred'));
      } finally {
        this.loading = false;
      }
    },
    async exportExcel() {
      this.exporting = true;
      try {
        const blob = await exportSuperviseurRapport(this.query);
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'rapport-activite-superviseur.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error(error);
        this.$message.error(this.$t('general.errorOccurred'));
      } finally {
        this.exporting = false;
      }
    },
  },
};
</script>
